// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__toayJ","left":"styles_left__2WfZ6"};